import { useAuth0 } from '@auth0/auth0-react';
import PersonIcon from '@mui/icons-material/Person';
import Avatar from '@mui/material/Avatar';
import { useTheme } from '@mui/material/styles';
import LoadingSpinner from '../commonUI/LoadingSpinner';

interface Props {
  pxSize?: number;
}

const UserAvatar: React.FC<Props> = ({ pxSize = 40 }) => {
  const theme = useTheme();
  const { user, isLoading } = useAuth0();

  let formattedName = '';
  if (user) {
    if (user.name) {
      formattedName = user.name.slice(0, 2).toUpperCase();
    }
  }

  return (
    <Avatar
      sx={{
        backgroundColor: theme.colors.common.bloomfieldGreen,
        color: theme.colors.common.darkGrey,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: `${pxSize}px`,
        height: `${pxSize}px`,
        borderRadius: 1,
      }}
      sizes='small'
    >
      {isLoading ? (
        <LoadingSpinner />
      ) : formattedName === '' ? (
        <PersonIcon />
      ) : user?.picture ? (
        <img
          referrerPolicy='no-referrer'
          src={user?.picture}
          style={{ width: '100%' }}
          alt='user avatar'
        />
      ) : (
        formattedName
      )}
    </Avatar>
  );
};

export default UserAvatar;
